export const getBusinessTypesFilterValue = (value?: string): string[] | undefined => {
  if (value === 'Yes') return ['company'];
  if (value === 'No') return ['sole-trader'];
  return undefined;
};
